import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import * as typeUtils from "../../../utils/typeUtils";
import { ACTION_PREFIX_PARAMETER } from "./abstract/parameterAbstract";
import { getParameterReferences } from "./helpers/parameterHelper";

const _action = `${ACTION_PREFIX_PARAMETER}_move_to_globals`;
const _header = `Move parameter`;

export const moveParameterToGlobals = (root, id, idTargetParent, indexDestination) => {
  const _payload = moveParameterToGlobalsLogic(root, id, idTargetParent, indexDestination);

  logger.logAction(_action, _payload, ACTION_PREFIX_PARAMETER);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const moveParameterToGlobalsLogic = (root, id, idDestinationParent, indexDestination) => {
  const { data: _node, index: _index } = getNodeById(root, id);
  if (!_node) {
    throw new Error("Parameter to move not found");
  }
  const { data: _nodeParent } = getNodeById(root, pathUtils.getIdParent(id));
  const { data: _nodeDestinationParent } = getNodeById(root, idDestinationParent);
  if (!_nodeDestinationParent) {
    throw new Error("Destination parent node not found");
  }
  const { data: _nodeCopy } = nodeUtils.copy(_node, {
    idParent: idDestinationParent,
  });

  const _indexParsed = indexDestination ?? nodeUtils.getParameters(_nodeDestinationParent).length;

  const _nodeBackup = systemUtils.createDeepCopy(_node);
  const _references = getParameterReferences(root, _node);

  addParameter(_nodeDestinationParent, _nodeCopy, _indexParsed);
  updateParameter(_node, _nodeCopy);
  updateReference(_node, _nodeCopy);

  return generatePayload(
    _nodeBackup,
    _index,
    _nodeParent,
    _indexParsed,
    _nodeDestinationParent,
    _nodeCopy,
    _references.description
  );
};

const addParameter = (nodeDestinationParent, nodeCopy, index) => {
  const funAdd = (e) => e.push(nodeCopy);
  const funPosition = (e) => e.splice(index, 0, nodeCopy);
  const fun = (e) => (!index && index !== 0 ? funAdd(e) : funPosition(e));

  nodeUtils.modifyParameters(nodeDestinationParent, fun, false);
};

const updateParameter = (node, nodeCopy) => {
  nodeUtils.setIdTarget(node, nodeUtils.getID(nodeCopy));
  nodeUtils.setType(node, typeUtils.getTypeParameterLinked());
  nodeUtils.setParameters(node, null);
  nodeUtils.setChoices(node, null);

  const _type = typeUtils.getTypeParameterGlobal();

  nodeUtils.setType(nodeCopy, _type);
  nodeUtils.visitAllParameters(nodeCopy, (e) => nodeUtils.setType(e, _type));
};

const updateReference = (node, nodeCopy) => {
  nodeUtils.addIdReference(nodeCopy, nodeUtils.getID(node));
};

//--------------------------------------------------------------------------------

const generatePayload = (
  node,
  index,
  nodeParent,
  indexDestination,
  nodeDestinationParent,
  nodeCopy,
  uuidReferences
) => {
  const _payload = {
    group: ActionGroupTypes.ADD,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    uuidDestinationParent: nodeUtils.getUUID(nodeDestinationParent),
    indexDestination: indexDestination,
    uuidCopy: nodeUtils.getUUID(nodeCopy),
  };

  return { ..._payload, ...uuidReferences };
};

const generatePayloadDescription = (node) => {

  return `Promote parameter '${nodeUtils.getName(node)}' to global and create a link.`;
}